import { buildSlice, CommonState, Row } from '~libs/reduxUtils';

import { getAll, getOne, typePrefix } from '~appointments/actions/careQualificationLevels';

const initialState: CommonState<Row> = {
  loading: 'idle',
  error: null,
  rows: [],
  row: { id: -1 },
};

const slice = buildSlice<CommonState<Row>, Row>(typePrefix, initialState, {
  commonConfig: { getAll, getOne },
  customActions: {
    clearQualifications(state) {
      state.rows = initialState.rows;
    },
  },
});

export const { clearQualifications, updateParams } = slice.actions;

export default slice.reducer;
